export const notificationConstants = {
    GET_NOTIFICATION_ACTION_REQUEST: 'GET_NOTIFICATION_ACTION_REQUEST',
    GET_NOTIFICATION_ACTION_SUCCESS: 'GET_NOTIFICATION_ACTION_SUCCESS',
    GET_NOTIFICATION_ACTION_FAILURE: 'GET_NOTIFICATION_ACTION_FAILURE'
}